import { FormFields } from 'hooks';
import { validateEmail, validateName, validatePassword } from '@utils';

export type SignUpFormFieldNames = 'firstName' | 'lastName' | 'email' | 'password';

export const formFields: FormFields<SignUpFormFieldNames> = {
  firstName: {
    name: 'firstName',
    initialValue: '',
    isRequired: true,
    validate: validateName,
    requiredMessage: 'First name is required'
  },
  lastName: {
    name: 'lastName',
    initialValue: '',
    isRequired: true,
    validate: validateName,
    requiredMessage: 'Last name is required'
  },
  email: {
    name: 'email',
    initialValue: '',
    isRequired: true,
    validate: validateEmail,
    requiredMessage: 'Email is required'
  },
  password: {
    name: 'password',
    initialValue: '',
    isRequired: true,
    validate: validatePassword,
    requiredMessage: 'Password is required'
  }
};
